export const ContainerClasses = {
  CONTAINER_FALSE: [],
  CONTAINER_TRUE: ['wf-container', 'wf-mx-auto'],
}